
import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import Breadcrumb from '@/components/Breadcrumb/index.vue'
import Hamburger from '@/components/Hamburger/index.vue'
import { UserModule } from '@/store/modules/user'
import Cookies from 'js-cookie'

@Component({
  name: 'Navbar',
  components: {
    Breadcrumb,
    Hamburger
  }
})
export default class extends Vue {
  get sidebar() {
    return AppModule.sidebar
  }

  get device() {
    return AppModule.device.toString()
  }

  get avatar() {
    return 'http://192.168.31.130:8080/layui/img/0.jpg'
    // return UserModule.avatar
  }

  language = ''

  private toggleSideBar() {
    AppModule.ToggleSideBar(false)
  }

  private async logout() {
    await UserModule.LogOut()
    this.$router.push('/login')
  }

  onLanguageChange(locale: string) {
    // console.log(locale, this.language, locale === this.language)
    if (locale !== this.language) {
      this.language == locale
      Cookies.set('language', locale)
      location.reload()
    }
  }

  mounted() {
    this.language = Cookies.get('language') || 'id'
    this.onLanguageChange(this.language)
  }
}
